import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import classes from './LoginPage.module.css';
import { getSubStatusApi } from '../http/http';
import Cookies from 'js-cookie';
import LanguageSelector from './LanguageSelector';
import { LanguageContext } from './LanguageContext';
import { LOGIN, COMMON, pageT } from '../utils/i18n';
import { countryCode } from '../utils/constants';
import { toast } from 'react-toastify';

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, LOGIN);
  const c = pageT(lang, COMMON);

  const [msisdn, setMsisdn] = useState(
    searchParams.get('mn') ? searchParams.get('mn') : ''
  );

  const [showChit, setShowChit] = useState(true);
  const [openChit, setOpenChit] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [closing, setClosing] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => setOpenChit(true), 600);
    setTimeout(() => setShowForm(true), 1200);
  }, []);

  useEffect(() => {
    if (Cookies.get('token')) {
      navigate('/home');
    }
  }, [navigate]);

  const displayNumber =
    msisdn && msisdn.trim().length > 10 ? msisdn.trim().slice(3) : msisdn;

  const handleChange = (e) => {
    const value = e.target.value ? e.target.value.trim() : '';
    setMsisdn(value.length <= 10 ? value : value.slice(0, 10));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (msisdn?.trim().length === 0) {
      toast.error(t.invalidNumber);
      return;
    }

    if (msisdn.length >= 8) {
      setLoginLoading(true);
      try {
        const res = await getSubStatusApi({
          mobileNumber: parseInt(msisdn, 10),
        });
        if (res.responseCode === 200) {
          if (res?.data?.accessToken)
            Cookies.set('token', res.data.accessToken);
          window.location.href = '/home';
        } else if (res.responseCode === 203) {
          toast.error(t.lowbalance);
        } else if (res.responseCode === 202) {
          toast.info(t.inprocess);
        } else if (res.responseCode === 204) {
          toast.error(t.notSub);
        } else {
          toast.error(t.errorMsg);
        }
      } catch (err) {
        console.log(err);
        toast.error(t.errorMsg);
      } finally {
        setLoginLoading(false);
      }
    } else {
      toast.error(t.invalidNumber);
    }
  };

  return (
    <div className={classes.reg_container}>
      <div className={classes.languageBox}>
        <LanguageSelector />
      </div>

      {showChit && (
        <div
          className={`${classes.chit} 
          ${openChit ? classes.open : ''} 
          ${closing ? classes.closing : ''}`}
        >
          <div className={classes.flap}></div>

          <div className={classes.envelope_body}>
            {showForm && (
              <form
                className={`${classes.reg_box} ${classes.inside_chit} ${classes.slide_form}`}
                onSubmit={handleSubmit}
              >
                <h2 className={classes.reg_title}>{t.title}</h2>

                <label className={classes.phoneLabel}>{t.numberLabel}</label>
                <div className={classes.phoneField}>
                  <div className={classes.phoneCode}>+{countryCode}</div>
                  <input
                    type="tel"
                    name="number"
                    placeholder={t.numberPlaceholder}
                    value={displayNumber}
                    onChange={handleChange}
                    className={classes.phoneInput}
                  />
                </div>

                <button
                  className={classes.reg_btn}
                  type="submit"
                  disabled={loginLoading}
                >
                  {loginLoading ? c.loading : t.login}
                </button>

                <Link className={classes.formLink} to={`/register`}>
                  {t.subscribeLink}
                </Link>
              </form>
            )}
          </div>
        </div>
      )}

      <div className={classes.floating_shapes}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default LoginPage;
